/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFT_HERO_922 from '../../sections/SSoft_Hero_922/SSoft_Hero';
import SSOFT_SERVICE_WHY_1336 from '../../sections/SSoft_Service_Why_1336/SSoft_Service_Why';
import SSOFT_LINE_SERVICES_924 from '../../sections/SSoft_Line_Services_924/SSoft_Line_Services';
import SSOFT_SERVICES_KEY_FEATURES_1179 from '../../sections/SSoft_Services_Key_Features_1179/SSoft_Services_Key_Features';
import SSOFT_CASE_STUDIES_1337 from '../../sections/SSoft_Case_Studies_1337/SSoft_Case_Studies';
import SSOFTNEW_OUR_CLIENT_1338 from '../../sections/SSoftNew_Our_Client_1338/SSoftNew_Our_Client';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'hero' : 'hero'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'why-choose-us' : 'why-choose-us'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'line-services' : 'line-services'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'case-study' : 'case-study'},
               { id: 5, slug: localStorage.getItem('language') === "English"? 'clients' : 'clients'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   section5 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section5') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section5.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Services | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> Services | Supersoft</title>;
                   break;
               default:
                   title = <title> Services | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='We specialise in meeting your companys technology needs to drive success - PT Supersoft' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Kami berspesialisasi dalam memenuhi kebutuhan teknologi perusahaan Anda untuk mendorong kesuksesan - PT Supersoft' />;
                   break;
               default:
                   description = <meta name='description' content='We specialise in meeting your companys technology needs to drive success - PT Supersoft' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFT_HERO_922 />
            </div>
            <div ref={this.section2}>
                <SSOFT_SERVICE_WHY_1336 />
            </div>
            <div ref={this.section3}>
                <SSOFT_LINE_SERVICES_924 />
            </div>
            <div ref={this.section4}>
                <SSOFT_CASE_STUDIES_1337 />
            </div>
            <div ref={this.section5}>
                <SSOFTNEW_OUR_CLIENT_1338 />
            </div>
           </>
       );
   }
}
export default withParams(project1);